import { useLocation } from 'react-router-dom';
import { Navigate, Outlet } from 'react-router';
import { auth, useAuthState } from 'api/services/firebase';
import useAccountStore from 'store/accountStore';

const TeamProtectedRoute = ({ redirectTo = '/?open=login', strict }) => {
  const { pathname } = useLocation();
  const redirectUrl = `${redirectTo}&back=${pathname.substring(1)}`;

  const [user] = useAuthState(auth);
  const { isTeam, isTeamAvailable } = useAccountStore(
    (state) => ({
      isTeam: state.activeAccount.teamId,
      isTeamAvailable: state.account.team,
    }),
  );

  if (strict && (!user || !isTeam)) {
    return <Navigate to={redirectUrl} />;
  }

  if (!strict && !isTeamAvailable) {
    return <Navigate to={redirectUrl} />;
  }

  return <Outlet />;
};

export default TeamProtectedRoute;
